import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Wobble.scss';
const Wobble = ({ size = 45, color = 'black', speed = 0.9, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsx("div", { className: styles.inner }) }));
};
export default Wobble;
